import styled from "@emotion/native";
import { View } from "react-native";
import { AppText } from "@toothfairy/shared-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import Constants from "../../Constants";

export const SideBar = styled(View, {
  shouldForwardProp: (prop) =>
    !["width", "height", "showMenu", "isPinned", "currentTheme"].includes(prop),
})`
  height: 100vh;
  background-color: rgb(246, 249, 252);
  width: ${({ showMenu }) =>
    showMenu ? `${Constants.sideMenuWidth}px` : "0px"};
  min-width: ${({ showMenu }) =>
    showMenu ? `${Constants.sideMenuWidth}px` : "0px"};
  overflow: hidden;
  transition: width 0.25s ease-in-out, min-width 0.25s ease-in-out;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const PinMenuText = styled(AppText)`
  padding: 10px 25px;
  width: 100%;
  text-align: center;
  cursor: pointer;
`;

export const PinMenu = ({ click }) => {
  const { t } = useTranslation();
  return <PinMenuText onClick={click}>{t("sidemenu.pinMenu")}</PinMenuText>;
};
